import { Client } from "@/service/client";
import { Chat } from "@/shared/model/chat.model";
import { Message } from "@/shared/model/message.model";

export class ChatApi {
  private client: Client;

  constructor(client: Client) {
    this.client = client;
  }

  async post(
    idProject: string,
    idSuggestion: string | null,
    ai_model: string
  ): Promise<Chat> {
    const response = await this.client.fetch(`/project/${idProject}/chat`, {
      method: "POST",
      body: JSON.stringify({ id_suggestion: idSuggestion, ai_model }),
    });

    const json = await response.json();

    return json.data;
  }

  async get(idProject: string, idChat: string): Promise<Chat> {
    const response = await this.client.fetch(
      `/project/${idProject}/chat/${idChat}`
    );

    const json = await response.json();

    return json.data;
  }

  async update(
    idProject: string,
    idChat: string,
    data: Partial<Chat>
  ): Promise<Chat> {
    const response = await this.client.fetch(
      `/project/${idProject}/chat/${idChat}`,
      {
        method: "PUT",
        body: JSON.stringify(data),
      }
    );

    const json = await response.json();

    return json.data;
  }

  async list(idProject: string): Promise<Chat[]> {
    const response = await this.client.fetch(`/project/${idProject}/chat`);

    const json = await response.json();

    return json.data;
  }

  async messagesList(idProject: string, idChat: string): Promise<Message[]> {
    const response = await this.client.fetch(
      `/project/${idProject}/chat/${idChat}/messages`
    );

    const json = await response.json();

    return json.data;
  }

  async send(
    idProject: string,
    idChat: string,
    text: string
  ): Promise<Message> {
    const response = await this.client.fetch(
      `/project/${idProject}/chat/${idChat}/messages`,
      {
        method: "POST",
        body: JSON.stringify({ text }),
      }
    );

    const json = await response.json();

    return json.data;
  }

  async delete(
    idProject: string,
    idChat: string,
    idMessage: string
  ): Promise<void> {
    await this.client.fetch(
      `/project/${idProject}/chat/${idChat}/messages/${idMessage}`,
      {
        method: "DELETE",
      }
    );
  }
}
